import React from 'react';

import Modal from 'components/curo-components/common/Modal';
import Button from 'components/digifi-wrappers/Button';
import { FailedIcon } from 'static/images';

interface IFailedDocumentsUploadModalProps {
  onClose: () => void;
}

const FailedDocumentsUploadModal = ({ onClose }: IFailedDocumentsUploadModalProps) => {
  return (
    <Modal
      actionElement={
        <Button size="form" kind="primary" onClick={onClose}>
          Retry
        </Button>
      }
      description="We were unable to upload your documents. Please try again."
      title="Your document upload failed"
      onClose={onClose}
      modalIcon={<FailedIcon />}
    />
  );
};

export default FailedDocumentsUploadModal;
